<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">
            <div class="row align-items-center text-start">
                <div class="col-7 col-12-narrower">
                    <div class="eyebrow" i18n>Legacy-Modernisierung</div>
                    <header>
                        <h2 i18n>Alte Businesssoftware auf den aktuellen Stand bringen</h2>
                    </header>
                    <p class="lead" i18n>Wir modernisieren <strong>gewachsene Unternehmenssoftware</strong> und übertragen bewährte Arbeitsabläufe in eine sichere, wartbare und zukunftsfähige Lösung.</p>
                    <p i18n>Ihre Mitarbeiter kennen die bestehenden Prozesse, doch die Technik ist veraltet, schwer zu warten oder nicht mehr erweiterbar? AlbCode entwickelt eine neue Anwendung, die sich an den etablierten Workflows orientiert und diese gezielt verbessert.</p>
                </div>
                <div class="col-5 col-12-narrower">
                    <div class="visual-frame modernization-preview">
                        <img src="/freepics/coding.jpg" alt="Modernisierung und Neuentwicklung bestehender Businesssoftware" i18n-alt />
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="wrapper">
    <section class="container">
        <header class="major text-center">
            <h2 i18n>Modernisieren, ohne wertvolles Wissen zu verlieren</h2>
        </header>
        <div class="row features g-4">
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon solid featured fa-magnifying-glass-chart"></span>
                    <h3 i18n>Bestehende Abläufe verstehen</h3>
                    <p i18n>Wir analysieren Funktionen, Daten, Schnittstellen und die tatsächliche tägliche Nutzung Ihrer bisherigen Businesssoftware.</p>
                </div>
            </section>
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon solid featured fa-code-branch"></span>
                    <h3 i18n>Schrittweise modernisieren</h3>
                    <p i18n>Je nach Ausgangslage ersetzen wir einzelne Module oder entwickeln die Anwendung kontrolliert neu – mit klar planbaren Übergängen.</p>
                </div>
            </section>
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon solid featured fa-shield-halved"></span>
                    <h3 i18n>Zukunftssicher weiterarbeiten</h3>
                    <p i18n>Moderne Technologien, Sicherheitsstandards und eine wartbare Architektur reduzieren Risiken und ermöglichen neue Funktionen.</p>
                </div>
            </section>
        </div>
    </section>
</div>

<div class="wrapper">
    <section class="container text-start">
        <div class="row align-items-stretch g-5">
            <div class="col-7 col-12-narrower content-copy">
                <header class="major">
                    <h2 i18n>Neue Technik auf Basis bewährter Workflows</h2>
                </header>
                <p i18n>Eine Modernisierung muss nicht bedeuten, alle Abläufe neu zu erfinden. Wir übernehmen die Prozesse, die sich bewährt haben, beseitigen technische Altlasten und schaffen dort Verbesserungen, wo Medienbrüche oder manuelle Arbeit heute Zeit kosten.</p>
                <ul class="service-list">
                    <li i18n>Ablösung veralteter Desktop-, Server- oder Intranet-Anwendungen</li>
                    <li i18n>Migration bestehender Daten und Dokumente</li>
                    <li i18n>Überführung in moderne, browserbasierte Businesssoftware</li>
                    <li i18n>Anbindung an aktuelle APIs und Drittsysteme</li>
                    <li i18n>Automatisierung manueller und mehrfach gepflegter Abläufe</li>
                    <li i18n>Langfristige Wartung und kontrollierte Weiterentwicklung</li>
                </ul>
            </div>
            <div class="col-5 col-12-narrower">
                <div class="visual-frame mb-4">
                    <img src="/freepics/agile.jpg" alt="Schrittweise Planung und Umsetzung einer Softwaremodernisierung" i18n-alt />
                </div>
                <div class="callout">
                    <h3 i18n>Ihre Software ist technisch überholt?</h3>
                    <p i18n>Wir prüfen gemeinsam, welche Funktionen bleiben sollen und wie ein sicherer Übergang aussehen kann.</p>
                    <a routerLink="/contact" class="glow-on-hover p-3" i18n>Modernisierung besprechen</a>
                </div>
            </div>
        </div>
    </section>
</div>
